import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { usePrivacyContentQuery } from "../../store/services/FaqsServices";
import Spinner from "../../utils/Loader";

const Privacy = () => {
	const { data, isFetching } = usePrivacyContentQuery();
	return (
		<>
			{!isFetching ? (
				<>
					<Header /> {/* Home and product sec  */}
					<section className="home-and-pro-sec">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="home-and-product">
										<p>
											<Link to="/"> Home </Link> <span>{">"}</span>
											<Link to="/">Privacy Policy</Link>
										</p>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Home product sec  */}
					{/* Inner banner heading  */}
					<section className="inner-banner">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="inner-banner-head">
										<h2>
											Privacy <span> Policy </span>
											{/* <p>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                                do eiusmod tempor incididunt <br></br> ut labore et dolore
                                magna aliqua. Ut enim ad minim veniam, quis nostrud
                                exercitation <br></br>
                                ullamco Laboris consequat.
                              </p> */}
										</h2>
									</div>
								</div>
							</div>
						</div>
					</section>
					{/* End of Inner heading  */}
					{/* Terms and condition  */}
					<section className="terms-sec">
						<div className="container">
							<div className="row">
								<div className="col-md-12">
									<div className="terms-para">
										<div
											dangerouslySetInnerHTML={{
												__html: data?.response?.data.content,
											}}
										></div>
									</div>
								</div>
							</div>
						</div>
						<div class="right-before">
							<figure>
								<img
									src="/static/media/easy-before.e66c4407932666308811.png"
									alt=""
									class="img-fluid"
								/>
							</figure>
						</div>
					</section>
					{/* End Of Terms Conditon  */} <Footer />
				</>
			) : (
				<Spinner />
			)}
		</>
	);
};

export default Privacy;
